import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import ImageButtonList from '../imageButtonList';
import './styles.css';

class ServiceNavigationBar extends Component {
  state = {
    buttons: []
  };

  /*******************
   * Lifecycle hooks *
   *******************/

  componentWillMount() {
    this.updateButtons();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.buttons !== this.state.buttons) {
      this.updateButtons(nextProps.buttons);
    }
  }

  updateButtons = (buttons = this.props.buttons) => {
    let btnsCopy = buttons.map(button => {
      if (button.unhighlightCache === undefined) {
        button.unhighlightCache = button.unhighlight.slice();
      }
      if (!button.hidden) {
        // HACK!
        if (button.disabled) {
          button.unhighlight = button.disable.slice();
        } else {
          button.unhighlight = button.unhighlightCache.slice();
        }
      }
      return button;
    });
    this.setState({
      buttons: btnsCopy.filter(({ hidden }) => hidden === false)
    });
  };

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    return (
      <div className="service-navigation-bar">
        <ImageButtonList
          id={this.props.id}
          imageButtons={Array.from(this.state.buttons)}
          flexClass="flex-horizontal"
          currentButton={this.props.currentButton || 0}
          handleKeyUp={this.props.handleKeyUp}
          unfocused={this.props.unfocused}
          disabled={this.props.disabled}
        />
      </div>
    );
  }
}

export default withRouter(ServiceNavigationBar);
